import { client as request } from "./request";

/**
 * サービスへの招待を送る
 *
 * @deprecated 招待機能リニューアルで廃止予定
 */
export async function inviteToService(staffId: any, mail: string) {
  const d = new FormData();
  d.append("staffId", String(staffId));
  d.append("mail", mail);
  await request.post("invite_service.php", d);
}

/**
 * 社員をサービスに追加する
 */
export async function addServiceUserStaff(staffId: string): Promise<void> {
  const data = new FormData();
  data.append("staff", staffId);
  await request.post("add_service_user_staff.php", data);
}

/**
 * サービスへの招待を受け入れる
 */
export async function acceptServiceInvitation(inviteCode: string) {
  const d = new FormData();
  d.append("inviteCode", inviteCode);
  const res = await request.post("accept_service_invitation.php", d);
  return res.serviceId;
}

/**
 * 現場への招待を受け入れる
 */
export async function acceptProjectInvitation(inviteCode: string) {
  const d = new FormData();
  d.append("inviteCode", inviteCode);
  await request.post("accept_project_invitation.php", d);
}
